import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "YesNo" })
export class YesNoPipe implements PipeTransform {
    transform(value: any): string | undefined {
        if (value === true) {
            return "Yes";
        } else if (value === false) {
            return "No";
        } else {
            return undefined;
        }
    }
}
